import Router from 'vue-router';
import axios from "axios";
import MainNavbar from './layout/MainNavbar.vue';
import MainFooter from './layout/MainFooter.vue';
import Login from './pages/Login.vue';
import Usuario from './pages/admin/Usuario.vue';
import Expatriado from './pages/colaborator/Expatriado.vue'
// import Shipper from './pages/colaborator/Shipper.vue'
import Company from './pages/colaborator/Company.vue'
import Operations from './pages/colaborator/Operations.vue';
import Profile from './pages/colaborator/Profile.vue';
import Dashboard from './pages/colaborator/Dashboard.vue';
import { Auth } from "aws-amplify";

let router = new Router({
  mode: "history",
  root: '/',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'Login',
      components: { default: Login },
      props: {
      }
    },
    {
      path: '/Operations',
      name: 'Operations',
      meta: {
        requiredAuth: true
      },
      components: { default: Operations, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/Profile',
      name: 'Profile',
      meta: {
        requiredAuth: true
      },
      components: { default: Profile, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/Dashboards',
      name: 'Dashboard',
      meta: {
        requiredAuth: true
      },
      components: { default: Dashboard, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/Users',
      name: 'Usuario',
      meta: {
        requiredAuth: true,
        permAdmin: true
      },
      components: { default: Usuario, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/Expats',
      name: 'Expatriado',
      meta: {
        requiredAuth: true,
      },
      components: { default: Expatriado, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    // {
    //   path: '/Shippers',
    //   name: 'Shipper',
    //   meta: {
    //     requiredAuth: true,
    //   },
    //   components: { default: Shipper, header: MainNavbar, footer: MainFooter },
    //   props: {
    //     header: { colorOnScroll: 400 },
    //     footer: { backgroundColor: 'black' }
    //   }
    // },
    {
      path: '/Companies',
      name: 'Company',
      meta: {
        requiredAuth: true,
      },
      components: { default: Company, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      name: 'RutaNoExiste',
      path: '*',
      component: Login
    }

  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});


router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiredAuth)) {
    Auth.currentSession()
      .then(async (data) => {
        localStorage.setItem("idToken", data["idToken"]["jwtToken"]);
        next()
        if (to.matched.some(record => record.meta.permAdmin)) {
          const token = localStorage.getItem("idToken");
          const { attributes } = await Auth.currentAuthenticatedUser();
          let email = attributes["email"];
          // console.log(`Bearer ${token}`)
          axios
            .get(
              `${process.env.VUE_APP_USERS}`,
              {
                params: {
                  depth: true,
                  user_email: email,
                },
                headers: { Authorization: `Bearer ${token}` }
              }
            )
            .then((res) => {
              // console.log(res.data[0])
              let profile_name = res.data[0]["profile_details"]["profile_name"];
              if (profile_name == "admin") {
                next();
              }
              else {
                router.replace({ name: 'Dashboard' }).catch(err => {
                })
              }
            })
            .catch((error) => {
              // console.log(error)
              sessionStorage.clear();
              localStorage.clear();
              router.replace({ name: 'Login' }).catch(err => {
              })
            });
        }
        else {
          next();
        }
      })
      .catch((err) => {
        // console.log(err)
        sessionStorage.clear();
        localStorage.clear();
        router.replace({ name: 'Login' }).catch(err => {
        })
      });
  } else {
    next()
  }
})

export default router;
